/**
 * Who is SHOWN device-session controls. Not who is allowed to use them.
 *
 * The Backend decides that, in `common/permission.py`, and answers 403 to
 * anyone else. This file exists so the button does not sit in front of
 * employees who would only ever be refused -- a control that always fails
 * is worse than no control -- and for no other reason.
 *
 * THE RULE IS THE ADMIN PRIVILEGE, READ WITH THE SHARED STRICT PARSER
 * ---------------------------------------------------------------
 * `employee.privilege` = Admin, the same value `SESSION_ME` returns and the
 * Backend decides with, so there is no second list to drift. The parsing
 * lives in `./privilege.ts` so that the employee form -- which now writes
 * this value -- and this check read it identically. Behaviour here did not
 * change when that moved; the tests in `device-session-permission.test.ts`
 * are what prove it.
 *
 * WHAT CAN STILL GO WRONG, AND WHY IT IS SAFE
 * ---------------------------------------------------------------
 * The role-preview tool in `nav.tsx` CAN dispatch `privilege: 1`, so on a
 * development build this can answer true for someone who is not an
 * administrator. That shows a button; it grants nothing. The Backend reads
 * the database and refuses with 403, and the preview tool is kept off
 * Production (`isProductionApi()` in `api-config.ts`). The failure direction
 * is always the harmless one.
 */
import { isAdminPrivilege } from './privilege';

export { PRIVILEGE_ADMIN } from './privilege';

/** Whether to offer device-session management to this privilege. */
export const mayManageDeviceSessions = (privilege: unknown): boolean =>
    isAdminPrivilege(privilege);
